import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Pagination } from '@lion-design/core';
import { I_NormGroup, I_SingleGroup } from '@Redux/search/interfaces';
import { setGroupListInfo, setSingleGroupListInfo } from '@Redux/search/actions';
import { RootState } from '@Redux/search/store';
import ResultNoData from '@components/SearchPage/ResultNoData';
import Skeleton from '@components/Common/Skeletons';
import getResultConditions, { I_ResultConditionsReturn } from '@utils/getResultConditions';
import CardsList from './CardsList';
import SingleList from './SingleList';
import styles from '../styles.module.scss';

export interface I_Props {
    isLogin: boolean;
    favList?: [{ ProductID: string }];
    setFavList: Function;
    productUrl: Function;
    handleIsFav: Function;
}

const Pc = ({ isLogin, favList, setFavList, productUrl, handleIsFav }: I_Props) => {
    const search = useSelector((state: RootState) => state.search);
    const isCards = search.SwitchListBy === 'List';
    const {
        GroupListInfo,
        SingleGroupListInfo,
        DepthInfo,
        FilterItems,
        SortType,
        TagFiltersShow,
        ChangeItem,
        Tags,
        callJson,
    } = search;
    const [isNowPage, setIsNowPage] = useState<number>(1);
    const dispatch = useDispatch();

    const { data: groupData, isLoading: isGroupDataLoading } = GroupListInfo;
    const { data: singleGroupData, isLoading: singleGroupLoading } = SingleGroupListInfo;

    const resultConditions = getResultConditions({
        DepthInfo,
        FilterItems,
        SortType,
        TagFiltersShow,
        ChangeItem,
        Tags,
    });

    const callGroupListInfo = (reqBody: I_ResultConditionsReturn) => {
        isCards ? dispatch(setGroupListInfo(reqBody)) : dispatch(setSingleGroupListInfo(reqBody));
    };

    // 進入頁面時打API
    useEffect(() => {
        const reqBody = {
            ...resultConditions,
            Page: 1,
            PageSize: 10,
        };
        callGroupListInfo(reqBody);
        setIsNowPage(1);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isCards, dispatch]);

    // 變更篩選條件時重新打API
    useEffect(() => {
        if (ChangeItem) {
            const reqBody = {
                ...resultConditions,
                Page: 1,
                PageSize: 10,
            };
            callGroupListInfo(reqBody);
            setIsNowPage(1);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [DepthInfo, FilterItems, SortType, TagFiltersShow]);

    // 頁數改變時重新打API
    const getCurPageList = (page: number) => {
        if (page === isNowPage) return;
        const reqBody = {
            ...resultConditions,
            Page: page,
            PageSize: 10,
        };
        callGroupListInfo(reqBody);
        setIsNowPage(page);
    };

    if (isCards ? isGroupDataLoading : singleGroupLoading)
        return <Skeleton part="cards" device="pc" />;
    if (
        isCards
            ? groupData.NormGroupList?.length === 0
            : singleGroupData.SingleGroupList?.length === 0
    )
        return <ResultNoData />;
    return (
        <>
            {isCards
                ? groupData.NormGroupList.length > 0 &&
                  groupData.NormGroupList.map((item: I_NormGroup, i: number) => (
                      <CardsList
                          key={i}
                          groupData={item}
                          isFaved={handleIsFav(item.GroupList[0].GroupID, favList)}
                          isLogin={isLogin}
                          setFavList={setFavList}
                          favList={favList}
                          productUrl={productUrl}
                      />
                  ))
                : singleGroupData.SingleGroupList.length > 0 && (
                      <>
                          <div className={styles.fakeHeader}>
                              <div className={styles.proName}>產品名稱</div>
                              <div className={styles.proDate}>日期</div>
                              <div className={styles.proAir}>航空</div>
                              <div className={styles.proStatus}>團況</div>
                              <div className={styles.proPrice}>售價</div>
                          </div>
                          {singleGroupData.SingleGroupList.map((item: I_SingleGroup, i: number) => (
                              <SingleList
                                  key={i}
                                  groupData={item}
                                  isFaved={handleIsFav(item.GroupID, favList)}
                                  isLogin={isLogin}
                                  setFavList={setFavList}
                                  favList={favList}
                                  productUrl={productUrl}
                                  callJson={callJson}
                              />
                          ))}
                      </>
                  )}

            <Pagination
                className={styles.pageBar}
                total={isCards ? groupData.TotalCount : singleGroupData.TotalCount}
                pageSize={10}
                current={isNowPage}
                onChange={(page) => {
                    getCurPageList(page);
                    // 換頁後跳至最放上
                    window.scrollTo({ top: 380, left: 0, behavior: 'smooth' });
                }}
            />
        </>
    );
};

export default Pc;
